import classNames from 'classnames';
import map from 'lodash/map';
import { Col, Row } from 'reactstrap';

import MarketingPageSection from 'src/app/components/Elements/MarketingPageSection';
import { Typography } from 'src/app/components/Elements/Typography';

import styles from './styles.module.scss';

type Sections = {
  title: string;
  text: string;
  mobileOrder?: string;
};

export interface PharmacyReasonProps {
  title: string;
  subtitle?: string;
  sections: Sections[];
}

const WhyPeopleLoveCapsule = ({ content, className }: { content: PharmacyReasonProps; className?: string }) => {
  const { title, subtitle, sections } = content;

  return (
    <MarketingPageSection className={classNames(styles.component, 'pt-0', className)}>
      <Row>
        <Col xs="12">
          <h2 className="xs-font-up-6 md-font-up-11 pb-2 pb-md-5">{title}</h2>
          {subtitle && (
            <Typography variant={'h3'} marginBottom={'s5'}>
              <i>{subtitle}</i>
            </Typography>
          )}
        </Col>
      </Row>
      <Row>
        <Col xs="12" className={styles.sectionContainer}>
          {map(sections, ({ title, text, mobileOrder }, i) => {
            return (
              <div
                className={classNames(styles.section, styles[`mobileOrder${mobileOrder}`])}
                key={`section--${title}--${i}`}
              >
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            );
          })}
        </Col>
      </Row>
    </MarketingPageSection>
  );
};

export default WhyPeopleLoveCapsule;
